'use client'

import { usePathname } from 'next/navigation'

import s from './PreviewBanner.module.sass'

export const PreviewBanner = () => {
    const pathname = usePathname()
    const currentPath = pathname.split('?')[0]

    return (
        <div className={s.Outer}>
            <h3>Preview mode active</h3>
            <a href={`/api/disable-draft?path=${currentPath ? encodeURIComponent(currentPath) : null}`}>
                Cancel preview mode
            </a>
        </div>
    )
}
